export class FieldConditions {
	constructor(form) {
		this.form = form;
		const subwrap = this.form.querySelector(".submit-button-wrapper");
		// "e30=" is the base64 encoding of "{}", representing an empty JSON object
		this.conditions = JSON.parse(
			atob(subwrap.dataset.dtbFieldConditions || "e30="),
		);
		this.fieldGroups = Array.from(
			this.form.querySelectorAll(".form-group"),
		);
		this.init();
	}

	init() {
		// Parse conditions and set initial visibility
		this.evaluateConditions();
		this.form.addEventListener("input", () => this.evaluateConditions());
	}

	showError(fieldGroup, message) {
		const existingError = fieldGroup.querySelector(".dtb-condition-error");
		if (existingError) {
			existingError.remove();
		}
		const errorDiv = document.createElement("div");
		errorDiv.className = "dtb-condition-error";
		errorDiv.style.color = "red";
		errorDiv.style.marginTop = "5px";
		errorDiv.textContent = "Field conditions: " + message;
		fieldGroup.appendChild(errorDiv);
	}

	evaluateConditions() {
		const formData = new FormData(this.form);

		Object.entries(this.conditions).forEach(([fieldIndex, conditions]) => {
			const fieldGroup = this.fieldGroups[fieldIndex];
			if (!fieldGroup) return;

			// Start with true and AND all conditions
			let isVisible = true;
			const existingError = fieldGroup.querySelector(
				".dtb-condition-error",
			);
			if (existingError) {
				existingError.remove();
			}
			conditionsLoop: for (const condition of conditions) {
				// Check for error condition first
				if (condition.error) {
					this.showError(fieldGroup, condition.error);
					isVisible = true;
					break;
				}

				if (!formData.has(condition.field)) {
					this.showError(
						fieldGroup,
						`The field ${condition.field} was not found in the form`,
					);
					isVisible = true;
					break;
				}

				const fieldValue = formData.get(condition.field);
				let conditionResult = false;

				switch (condition.operator) {
					case "==":
						conditionResult =
							fieldValue == condition["right-value"];
						break;
					case "!=":
						conditionResult =
							fieldValue != condition["right-value"];
						break;
					case ">":
						conditionResult =
							parseFloat(fieldValue) >
							parseFloat(condition["right-value"]);
						break;
					case "<":
						conditionResult =
							parseFloat(fieldValue) <
							parseFloat(condition["right-value"]);
						break;
					case "contains":
						conditionResult = fieldValue.includes(
							condition["right-value"],
						);
						break;
					case "notcontains":
						conditionResult = !fieldValue.includes(
							condition["right-value"],
						);
						break;
					case "regex":
						try {
							const regex = new RegExp(condition["right-value"]);
							conditionResult = regex.test(fieldValue);
						} catch (e) {
							this.showError(
								fieldGroup,
								`Invalid regex pattern: ${condition["right-value"]}`,
							);
							isVisible = true;
							break conditionsLoop;
						}
						break;
					case "empty":
						conditionResult = fieldValue === "";
						break;
					case "not_empty":
						conditionResult = fieldValue !== "";
						break;
					case "in":
						const values = condition["right-value"]
							.split(",")
							.map((v) => v.trim());
						conditionResult = values.includes(fieldValue);
						break;
				}

				// If any condition fails, the whole group should be hidden
				if (!conditionResult) {
					isVisible = false;
					break;
				}
			}

			fieldGroup.style.display = isVisible ? "" : "none";
		});
	}
}
